import React from "react";
import { datadogLogs } from "@datadog/browser-logs";
import { config } from "../config/config";
import { env } from "../env/env";

const dataDogToken = config.datadogToken;
if (dataDogToken) {
  datadogLogs.init({
    clientToken: dataDogToken,
    site: "datadoghq.com",
    service: "stone-frontend",
    version: env.NX_PUBLIC_COMMIT,
    env: env.NODE_ENV === "production" ? "prod" : "staging",
    forwardConsoleLogs: "all",
    forwardReports: "all",
  });
}

export function Logging(props: React.PropsWithChildren) {
  return props.children;
}
export const logger = datadogLogs.logger;
